export default {"src":"/_next/static/media/Development.fe3ec832.svg","height":48,"width":48};